import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { groupBy } from 'lodash'

import { observer } from 'mobx-react'

import SingleChoiceFilter from 'modules/core/components/Filter/filters/SingleChoice'
import i18n from 'modules/core/lib/i18n'

import { LoadingSkeleton } from 'modules/notifications/components/LoadingSkeleton'
import { useNotificationsRequests } from 'modules/notifications/hooks/useNotificationsRequests'

import { LoadingSkeletonResumeBox } from './LoadingSkeletonResumeBox'
import { RequestItems } from './RequestItems'
import ResumeBox from './ResumeBox'

const RequestsPage = () => {
  const [filterBy, setFilterBy] = React.useState<string>()

  const {
    loading: isLoading,
    requests,
    removeRequestById,
    avatarUsersMap,
  } = useNotificationsRequests()

  const requestsByType = groupBy(requests, 'categoryIdentifier')

  const requestsByTypeList = Object.entries(requestsByType)

  const createOptions = requestsByTypeList.map((request) => {
    return { label: `${request[1][0]?.categoryTitle} (${request[1].length})`, value: request[0] }
  })

  const filterRequests = filterBy
    ? requests.filter((item) => item.categoryIdentifier === filterBy)
    : requests

  return (
    <Box>
      <Box flexDirection="row" paddingBottom="s32" gap="s16">
        {isLoading ? <LoadingSkeletonResumeBox /> : <ResumeBox requests={requests} />}
      </Box>

      <Box>
        {isLoading ? (
          <LoadingSkeleton />
        ) : (
          <>
            {!!requests.length && (
              <Box alignItems="flexStart" paddingBottom="s16">
                <SingleChoiceFilter
                  label={
                    filterBy
                      ? i18n.t('dashboard.requests.filters.filter')
                      : i18n.t('dashboard.requests.filters.all')
                  }
                  options={createOptions}
                  onValueChange={(item) => setFilterBy(item)}
                  value={filterBy}
                  header={
                    <Box padding="s16">{i18n.t('dashboard.requests.filters.select_category')}</Box>
                  }
                />
              </Box>
            )}

            <Box alignItems="center" width="full">
              <RequestItems
                requests={filterRequests}
                removeRequestById={removeRequestById}
                avatarUsersMap={avatarUsersMap}
              />
            </Box>
          </>
        )}
      </Box>
    </Box>
  )
}

export default observer(RequestsPage)
